import { Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import { resolveVersion } from '@/versions/registry';
import { usePinnedVersion } from './version-query-preserver';

// Reads ?v=<id> from the URL and mounts the matching version's root component.
// Each version is a fully self-contained tree (its own chrome, scenes, tokens)
// so opening /?v=1 and /?v=2 in two tabs renders honest side-by-side snapshots.
// A URL that lost ?v= in an in-app navigation keeps the pinned version
// (VersionQueryPreserver puts ?v= back in its next effect).
export function VersionSwitch() {
  const [params] = useSearchParams();
  const pinned = usePinnedVersion();
  const version = resolveVersion(params.get('v') ?? pinned);
  const Component = version.Component;
  // `key` forces a full remount when the version changes, so stale chrome /
  // ephemeral state never bleeds across version switches in the same tab.
  // Every `Component` is `lazy`, so the version's chunk loads here on first
  // selection. The fallback renders nothing: the body backdrop (global.css's
  // radial washes over `--background`) is already the app's empty canvas.
  return (
    <Suspense fallback={null}>
      <Component key={version.id} />
    </Suspense>
  );
}
